export function validateName(name) {
  return /^[\w\s\-а-яА-ЯёЁ]+$/.test(name.trim());
}